import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance } from 'vue';

import {
  formatWithLocale,
  DATE_TIME_FORMATS,
} from '@white-label-helper/date-utilities';


export default /*#__PURE__*/_defineComponent({
  __name: 'b-ticket-travel-insurance-traveller-details',
  props: {
  product: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const { proxy } = getCurrentInstance() as any;
const i18n = proxy.$i18n;



const travellers = computed((): Array<any> => {
  return (props.product && props.product.quoteDetails && props.product.quoteDetails.travellers) || [];
});

const countryOfResidence = computed((): String => {
  return (travellers.value.length > 0 && travellers.value[0].countryOfResidence) || '';
});

const formatDate = (date: string) => {
  return formatWithLocale(new Date(date), DATE_TIME_FORMATS.day_month_full_year_slash, i18n.locale.value);
};

return { __sfc: true,proxy, i18n, props, travellers, countryOfResidence, formatDate }
}

})